import * as React from 'react';
import { Button } from '@vechaiui/react';
import { Form } from 'formik';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useLocalization } from '@fluent/react';
import { useMutation } from '@apollo/client';

import Formik from '#/components/forms/Formik';
import LoginLayout from '#/layouts/LoginLayout';
import ResetPasswordForm from '#/components/forms/ResetPasswordForm';
import yup from '#/libs/yup';
import { PublicRoute } from '#/constants/page-route';
import { RESET_PASSWORD_INITIAL_VALUES } from '#/constants/form-initial-values';
import { ResetPasswordDocument } from '#/__generated__/graphql/graphql';
import { resetPasswordSchema } from '#/constants/validation-schema';

const ResetPasswordPage = () => {
  const [resetPasswordMutation] = useMutation(ResetPasswordDocument);
  const { l10n } = useLocalization();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const [apiErrors, setApiErrors] = React.useState<{ message: string }[]>();

  return (
    <LoginLayout>
      <div>
        <Formik
          initialValues={RESET_PASSWORD_INITIAL_VALUES}
          onSubmit={async (formData, { resetForm }) => {
            try {
              const token = searchParams.get('token');

              if (!token) {
                alert('Token not found. Please contact MOVE team.');
                return;
              }

              await resetPasswordMutation({
                variables: { input: { newPassword: formData.confirmPassword, token } },
              });
              resetForm();
              navigate(PublicRoute.Login);
            } catch (err: any) {
              if (err.errors) {
                setApiErrors(err.errors);
              } else if (err.networkError?.result.errors) {
                setApiErrors(err.networkError.result.errors);
              } else {
                setApiErrors([err]);
              }
              alert(!!apiErrors && apiErrors[0].message.replace('ApolloError:', ''));
            }
          }}
          validationSchema={yup.object(resetPasswordSchema)}
        >
          {(formikProps) => (
            <Form>
              <header className="mb-8">
                <h1 className="text-3xl font-bold">{l10n.getString('reset-password')}</h1>
              </header>

              <ResetPasswordForm />

              <footer className="mt-8">
                <div className="space-y-6">
                  <div className="flex flex-col gap-y-5">
                    <Button
                      className="w-full"
                      color="primary"
                      size="xl"
                      type="submit"
                      variant="solid"
                    >
                      {l10n.getString('confirm')}
                    </Button>
                    <Link to={PublicRoute.Login}>
                      <Button className="w-full" size="xl" type="submit" variant="solid">
                        {l10n.getString('back')}
                      </Button>
                    </Link>
                  </div>
                </div>
              </footer>
            </Form>
          )}
        </Formik>
      </div>
    </LoginLayout>
  );
};

export default ResetPasswordPage;
